import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';

import * as authActions from '@store/auth/auth.actions';
import * as authSelectors from '@store/auth/auth.selectors';

import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { map } from 'rxjs/operators';
import { IAuthCustomer } from '../core/models/auth.model';
import { StorageService } from '../data/browser/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  public phone$: Observable<string>;
  public customer$: Observable<IAuthCustomer>;
  public resend$: Observable<boolean>;
  public otpIsLoading$: Observable<boolean>;
  public error$: Observable<boolean>;
  public time$: Observable<number>;
  public currentTime$: Observable<number>;
  public countErrorOTP$: Observable<number>;

  constructor(private _store: Store, private _storaService: StorageService) {
    this.phone$ = this._store.select(authSelectors.selectPhone);
    this.customer$ = this._store.select(authSelectors.selectCustomer);
    this.resend$ = this._store.select(authSelectors.selectResend);
    this.otpIsLoading$ = this._store.select(authSelectors.selectOtpIsLoading);
    this.error$ = this._store.select(authSelectors.selectError);
    this.currentTime$ = this._store.select(authSelectors.selectCurrentTime);
    this.countErrorOTP$ = this._store.select(authSelectors.selectCountErrorOTP);
    this.time$ = combineLatest([this.resend$, this.countErrorOTP$, this.currentTime$]).pipe(
      map(([resend, countErrorOTP, currentTime]) => {
        if (!!resend) {
          return countErrorOTP >= 3 ? CONST.TIMER_PENALTY_SECONDS : CONST.TIMER_SECONDS;
        }
        return countErrorOTP == 3 ? CONST.TIMER_PENALTY_SECONDS : currentTime;
      })
    );
  }

  public requestLoginCode(phone: string, resend: boolean, token?: string) {
    this._store.dispatch(authActions.requestLoginCode({ phone, resend, token }));
  }

  public saveAuthCustomer(customer: IAuthCustomer) {
    const key: string = CONST.PROP_CUSTOMER;
    const jsonCustomer: string = JSON.stringify(customer);
    return this._storaService.setItem(key, jsonCustomer);
  }

  public getAuthCustomer(): IAuthCustomer {
    const key: string = CONST.PROP_CUSTOMER;
    const customer: string = localStorage.getItem(key);
    return JSON.parse(customer);
  }

  public removeAuthCustomer() {
    const key: string = CONST.PROP_CUSTOMER;
    return this._storaService.removeItem(key);
  }

  public setCaptcha(token: string) {
    this._store.dispatch(authActions.setCaptcha({ token }));
  }

  public setCurrentTime(currentTime: number) {
    this._store.dispatch(authActions.setCurrentTime({ currentTime }));
  }
}
